export { AnimationStyles, AnimationVariables } from '@fluentui/theme';
